export default __webpack_public_path__ + "static/media/Home-Assist-Logo.674e9545.svg";